<!--
 * @Date: 2020-09-01 17:25:46
 * @Author: MX
 * @LastAuthor: WZ
 * @LastEditTime: 2022-11-21 11:15:11
 * @Description: 控制台
-->
<template>
  <div class="control main-wrap">
    <div class="control-wrap" v-if="this.authLevel != null">
      <div class="main-left">
        <div class="main-left-header">
          <span class="line"></span>
          {{$lang('API服务')}}
        </div>
        <div class="main-left-aside">
          <div class="main-left-aside-item" v-for="(item, index) in asideList" :key="index" :class="{ active: tabActive === index }" @click="tabTip(index)">
            <span>{{ $lang(item.label) }}</span>
          </div>
        </div>
      </div>
      <div class="main-right">
        <div class="main-right-header"  :class="$i18n.locale">
          <div class="right-header-item">
            <i class="iconfont iconkongzhitai_wanchengbuzhou"></i>
            <div class="right-header-flex">
              <span class="title">{{$lang('注册用户')}}</span>
              <span class="subTitle" :class="$i18n.locale" :title="$lang('注册成为极兔开放平台用户')">{{$lang('注册成为极兔开放平台用户')}}</span>
            </div>
            <i class="iconfont iconbuzhouhongsejiantou"></i>
          </div>
          <div class="right-header-item">
            <i class="iconfont iconkongzhitai_wanchengbuzhou" v-if="tabActive !== 0"></i>
            <span class="circle" v-if="tabActive === 0">2</span>
            <div class="right-header-flex">
              <span class="title">{{$lang('开发者认证')}}</span>
              <span class="subTitle" :title="$lang('填写信息获取接口权限')">{{$lang('填写信息获取接口权限')}}</span>
            </div>
            <i class="iconfont iconbuzhouhongsejiantou" :class="{ grayColor: tabActive === 0 }"></i>
          </div>
          <div class="right-header-item">
            <i class="iconfont iconkongzhitai_wanchengbuzhou" v-if="tabActive >= 2"></i>
            <span class="circle" v-if="tabActive <= 1" :class="{ grayClass: tabActive === 0 }">3</span>
            <div class="right-header-flex">
              <span class="title">{{$lang('企业认证')}}</span>
              <span class="subTitle" :title="$lang('填写信息获取全部接口权限')">{{$lang('填写信息获取全部接口权限')}}</span>
            </div>
            <i class="iconfont iconbuzhouhongsejiantou" :class="{ grayColor: tabActive <= 1 }"></i>
          </div>
          <div class="right-header-item">
            <i class="iconfont iconkongzhitai_wanchengbuzhou" v-if="tabActive >= 3"></i>
            <span class="circle" v-if="tabActive <= 2" :class="{ grayClass: tabActive <= 1 }">4</span>
            <div class="right-header-flex">
              <span class="title">{{$lang('上线联调')}}</span>
              <span class="subTitle" :title="$lang('发起申请联调测试接口性能')">{{$lang('发起申请联调测试接口性能')}}</span>
            </div>
            <i class="iconfont iconbuzhouhongsejiantou" :class="{ grayColor: tabActive <= 2 }"></i>
          </div>
          <div class="right-header-item">
            <!-- <i class="iconfont iconkongzhitai_wanchengbuzhou" v-if="tabActive !== 0" ></i> -->
            <span class="circle" v-if="tabActive >= 0" :class="{ grayClass: tabActive < 3 }">5</span>
            <div class="right-header-flex">
            <span class="title">{{$lang('发布上线')}}</span>
            <span class="subTitle" :title="$lang('根据联调结果进行接口上线')">{{$lang('根据联调结果进行接口上线')}}</span>
            </div>
          </div>
        </div>
        <div class="main-right-content" :class="$i18n.locale">
          <div class="content-item" v-show="tabActive === 0">
            <h3><i class="iconfont iconapiwendang_jianjie"></i><span>{{$lang('公司信息')}}</span></h3>
            <div class="audit-status">
              <div class="status"><i class="iconfont" :class="{ iconshenhezhuangtai_weishenqingshibai: auditStatus === ''|| auditStatus === 3, iconshenhezhuangtai_shenhezhong: auditStatus === 0|| auditStatus === 1, iconshenhezhuangtai_tongguo: auditStatus === 2}"></i>{{$lang('审核状态')}}：<span>{{auditStatus | statusFilter}}</span></div>
              <div class="reason" v-if="auditStatus === 3">{{$lang('失败原因')}}：<span :title="failReason">{{failReason}}</span></div>
            </div>
            <el-form ref="controlForm" :rules="rules" label-width="180px" :model="controlForm" label-suffix="：">
              <el-form-item prop="enterpriseName" >
                <template slot="label">
                  <span  :title="$lang('公司全称')">{{$lang('公司全称') + '：'}}</span>
                </template>
                <el-input v-model="controlForm.enterpriseName" :placeholder="$lang('请输入公司全称')" :disabled="controlFormDisable||editDisable"></el-input>
              </el-form-item>
              <el-form-item class="address" prop="address">
                <template slot="label">
                  <span  :title="$lang('公司地址')">{{$lang('公司地址')+ '：'}}</span>
                </template>
                    <BaseAddress style="450px" ref="receiverProvinceSearch" :initAddressData="receiverAddressData" :showLevel="3" v-model="controlForm.receiveAddress" :disabled="controlFormDisable||editDisable">
                    </BaseAddress>
                <!-- <el-select :placeholder="$t('controlPage.请输入酋长国')" v-model="controlForm.userProvinceName" :disabled="controlFormDisable||editDisable" @change="dataProvinceChange($event)" filterable :title="controlForm.userProvinceName">
                  <el-option
                    v-for="item in provinceArray"
                    :key="item.id"
                    :label="item.nativeName"
                    :value="item.id"
                  />
                </el-select>
                <el-select :placeholder="$t('controlPage.请输入区域')" v-model="controlForm.userCityName" :disabled="controlFormDisable||editDisable" style="margin-left: 10px;" @change="dataCityChange($event)" filterable :title="controlForm.userCityName">
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.nativeName"
                    :value="item.id"
                  />
                </el-select> -->
              </el-form-item>
              <el-form-item prop="userDetailedAddress">
                <template slot="label">
                  <span  :title="$t('controlPage.公司详细地址')">{{$t('controlPage.公司详细地址') + '：'}}</span>
                </template>
                <el-input class="input" v-model.trim="controlForm.userDetailedAddress" :placeholder="$lang('请输入公司详细地址')" :disabled="controlFormDisable||editDisable" :title="controlForm.userDetailedAddress"></el-input>
              </el-form-item>
              <el-form-item prop="enterpriseType">
                <template slot="label">
                  <span  :title="$lang('客户类型')">{{$lang('客户类型') + '：'}}</span>
                </template>
                <el-select v-model="controlForm.enterpriseType" :placeholder="$lang('请选择')" :disabled="controlFormDisable||editDisable">
                  <el-option v-for="item in enterpriseTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <h3 style="margin-top:50px">
                <i class="iconfont iconkongzhitai_kaifazherenzheng"></i>{{$lang('接口联系人')}}
              </h3>
              <el-form-item prop="userName">
                <template slot="label">
                  <span  :title="$lang('IT接口联系人')">{{$lang('IT接口联系人') + '：'}}</span>
                </template>
                <el-input v-model="controlForm.userName" :placeholder="$lang('请输入开发者姓名')" :disabled="editDisable"></el-input>
              </el-form-item>
              <el-form-item prop="userEmail">
                <template slot="label">
                  <span  :title="$lang('IT接口邮箱')">{{$lang('IT接口邮箱') + '：'}}</span>
                </template>
                <el-input v-model="controlForm.userEmail" :placeholder="$lang('请输入邮箱地址')" :disabled="editDisable"></el-input>
              </el-form-item>
              <el-form-item prop="userPhone">
                <template slot="label">
                  <span  :title="$lang('IT联系电话')">{{$lang('IT联系电话') + '：'}}</span>
                </template>
                <el-input v-model="controlForm.userPhone" :placeholder="$lang('请输入开发者手机号码')" :disabled="editDisable" class="userPhone">
                  <template #prepend>
                    <el-select v-model="controlForm.countryCode" :placeholder="$lang('区号')" :disabled="editDisable">
                      <el-option
                        v-for="item in countryCodeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </template>
                </el-input>
              </el-form-item>
              <!-- TODO: 直接删除手机验证码 -->
              <!-- <el-form-item prop="captcha" class="captchaItem">
                <template slot="label">
                  <span  :title="$lang('手机验证码')">{{$lang('手机验证码') + '：'}}</span>
                </template>
                <el-input v-model="controlForm.captcha" maxlength="10" :placeholder="$lang('请输入验证码')" :disabled="editDisable"></el-input>
                <button class="commonBtn sendCode" @click.prevent="sendCodeBefore" :disabled="isSendCode || editDisable">
                  <span v-if="!isSendCode">{{$lang('发送')}}</span>
                  <span v-else>{{ time }}{{$lang('秒')}}</span>
                </button>
              </el-form-item> -->
            </el-form>
            <!-- 用户初次认证，是提交按钮 -->
            <button v-if="!auditStatus && auditStatus !== 0 " class="commonBtn nextStep" @click.prevent="nextStep">
              {{ $lang('提交') }}
            </button>
            <!-- 用户修改，显示修改，返回保存 -->
            <div v-else>
              <button v-if="editDisable" class="commonBtn nextStep" @click.prevent="openEdit">
                {{ $lang('修改') }}
              </button>
              <div v-else style="margin-top: 28px;">
                <button class="commonBtn back" @click.prevent="backStep">
                  {{ $lang('返回') }}
                </button>
                <button class="commonBtn save" @click.prevent="nextStep">
                  {{ $lang('保存') }}
                </button>
              </div>
            </div>
          </div>
          <div class="content-item" v-if="tabActive === 1">
            <companyAuth :addressOptions="addressOptions" :getFirsting="getFirsting" :companyAuthFormSend="companyAuthFormSend" :auditStatus="auditStatus" :authLevel="authLevel" :failReason="failReason" :firstPast="firstPast" :companyEdit="companyEdit" @companyAuthSuccess="companyAuthSuccess" @pageActive="pageActive"></companyAuth>
          </div>
          <div class="content-item" v-if="tabActive === 2">
            <p class="sandbox-title">{{$lang('提示：您需先在沙箱环境将需上线的所有接口进行联调，并且需成功三次或以上才能提交正式环境的申请')}}</p>
            <el-tabs v-model="sandboxActive">
              <el-tab-pane :label="$lang('订阅类')" name="first">
                <Sandbox status="0"></Sandbox>
              </el-tab-pane>
              <el-tab-pane :label="$lang('注册类')" name="second">
                <Sandbox status="1"></Sandbox>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="content-item" v-if="tabActive === 3">
            <el-tabs v-model="activeName">
              <el-tab-pane :label="$lang('订阅类')" name="first">
                <InterfaceManage :allowApply="allowApply" status="0"></InterfaceManage>
              </el-tab-pane>
              <el-tab-pane :label="$lang('注册类')" name="second">
                <InterfaceManage :allowApply="allowApply" status="1"></InterfaceManage>
              </el-tab-pane>
            </el-tabs>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { RULES } from "@/constants/rules";
import { RESPONSE_SUCCESS } from "@/constants";
import CompanyAuth from "./CompanyAuth";
import InterfaceManage from "./InterfaceManage";
import Sandbox from "./Sandbox";
import { mapGetters, mapActions } from "vuex";
import { lang } from "@utils/filters";
import BaseAddress from "@/components/BaseAddress"
export default {
  name: "Control",
  props: {},
  components: {
    CompanyAuth,
    InterfaceManage,
    Sandbox,
    BaseAddress
  },
  data() {
    return {
      activeName: "first",
      sandboxActive: "first",
      tabActive: 0,
      authLevel: null, //已认证等级
      editDisable: false,
      controlFormDisable: false,
      auditStatus: "", // 开放平台三期-审核状态
      failReason: "", // 开放平台三期-失败原因
      firstPast: false, // 用户第一步走完，改为true
      allowApply: false, //是否允许开发者申请api  ： auditStatus 状态值为 (0,"已提交"),(1,"未认证"),(2,"已认证"),(3,"禁用");
      companyEdit: false, // 决定用户企业信息是修改还是提交
      asideList: [
        {
          label: "开发者认证",
          level: 0,
        },
        {
          label: "企业认证",
          level: 1,
        },
        {
          label: "沙箱管理",
          level: 2,
        },
        {
          label: "接口管理",
          level: 3,
        },
      ],
      controlForm: {
        userName: "", //用户名
        userPhone: "", //手机号
        userEmail: "", //邮箱
        enterpriseName: "", //企业全称
        enterpriseType: "", //企业类型
        userProvinceId: "",
        userProvinceName: "",
        userCityId: "",
        userCityName: "",
        userAreaId: "",
        userAreaName: "",
        userDetailedAddress: "", //详细地址
        captcha: "", //验证码
        receiveAddress: {},
        countryCode: 55 // 区号
      },
      countryCodeList: [
        {
          label: "+55",
          value: 55
        },
        {
          label: "+86",
          value: 86
        }
      ],
      // 开放平台三期-需要传给企业认证子组件的表单信息-start
      companyAuthFormSend: {
        socialCreditCode: "", //社会信用代码
        businessLicensePath: "", //企业工商执照影印件
        corporationName: "", //法人姓名
        corporationCardId: "", //身份证
        corporationProvinceId: "", //省
        corporationProvinceName: "",
        corporationCityId: "", //市
        corporationCityName: "",
        corporationDetailedAddress: "", //详细地址
        corporationPhotoPath: "", //身份证照片
        receiveAddress: {},
      },
      // 开放平台三期-需要传给企业认证子组件的表单信息-end
      loginLoading: false,
      remember: false,
      rules: {
        enterpriseName: [
          {
            required: true,
            message: lang("请输入合法的公司名称"),
            trigger: ["blur", "change"],
          },
        ],
        enterpriseType: [
          {
            required: true,
            message: lang("请选择客户类型"),
            trigger: ["blur", "change"],
          },
        ],
        userName: [
          {
            required: true,
            message: lang("请输入姓名"),
            trigger: ["blur", "change"],
          },
          // RULES.noBlankSpace,
        ],
        userEmail: [
          {
            required: true,
            message: lang("请输入正确的邮箱账号"),
            trigger: ["blur", "change"],
          },
          RULES.email,
        ],
        userDetailedAddress: [
          {
            required: true,
            message: lang("请输入详细地址"),
            trigger: ["blur", "change"],
          },
          // RULES.noBlankSpace,
        ],
        address: [
          {
            required: true,
            validator: this.receiveAddress,
            trigger: ["blur", "change"],
          },
        ],
        userPhone: [RULES.phone, RULES.checkPhone],
        captcha: [RULES.phoneCode, RULES.noBlankSpace],
      },
      getFirsting: true,
      isSendCode: false,
      time: 60,
      codeTimer: null,
      addressOptions: [], //层级下拉
      provinceArray: [],
      cityList: [],
      enterpriseTypeOptions: [
        {
          value: "1",
          label: lang("平台"),
        },
        {
          value: "2",
          label: lang("软件供应商"),
        },
        {
          value: "3",
          label: lang("商家自研系统"),
        },
        {
          value: "4",
          label: lang("其他"),
        },
      ],
      receiverAddressData: {
        //公司地址
        formProps: {
          provinceIdProp: "userProvinceId",
          provinceNameProp: "userProvinceName",
          cityIdProp: "userCityId",
          cityNameProp: "userCityName",
          areaIdProp: "userAreaId",
          areaNameProp: "userAreaName",
        },
        defaultData: {},
      },
    };
  },
  computed: {
    ...mapGetters(["user", "token", "uuid"]),
  },
  watch: {
    auditStatus: {
      handler(newVal) {
        this.controlFormDisable = newVal === 2;
        this.editDisable = !newVal && newVal !== 0 ? false : true;
        this.firstPast = !newVal && newVal !== 0;
      },
      deep: true,
      immediate: true,
    },
    authLevel: {
      handler(newVal) {
        // 判断企业认证是否是修改状态 , newVal等于1 说明是在企业认证页面，this.auditStatus>=1 说明用户之前提交过企业认证信息，这时候才能是true
        this.companyEdit = newVal >= 1 && this.auditStatus >= 1;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    if (this.token) {
      this.getAreaList();
      //判断是否认证
      this.isAuth();
    } else {
      this.$router.push({ path: "/register" });
    }
  },
  filters: {
    statusFilter(val) {
      const myMap = new Map([
        [0, "审核中"],
        [1, "审核中"],
        [2, "认证通过"],
        [3, "认证不通过"],
      ]);
      return myMap.get(val) ? lang(myMap.get(val)) : lang("未申请");
    },
  },
  methods: {
    ...mapActions(["SET_UUID"]),
    sendCodeBefore() {
      if (!this.controlForm.userPhone) {
        return this.$message.warning(this.$lang("请输入手机号"));
      }
      this.sendCode();
    },
    /**
     * @description 左侧点击
     */
    tabTip(num) {
      if (num === 0) {
        const {
          userProvinceId,
          userProvinceName,
          userCityId,
          userCityName,
          userAreaId,
          userAreaName,
        } = this.controlForm;
        // 回显公司省市区，用户一进来停留在企业认证页面，开发者页面的地址回显有问题，没有触发watch函数，这里手动保存触发(其实之前dataEcho函数已经保存了)
        this.receiverAddressData.defaultData = {
          userProvinceId,
          userProvinceName,
          userCityId,
          userCityName,
          userAreaId,
          userAreaName,
        };
      }
      this.tabActive = num;
    },
    /**
     * @description 发送验证码
     */
    sendCode() {
      // 210812 发送验证码加区号
      let httpParams = {
        countryCode: this.controlForm.countryCode,
        phone: this.controlForm.userPhone,
        type: "dev_cer",
      };
      this.$API.sendMessage(httpParams).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isSendCode = true;
          clearInterval(this.codeTimer);
          this.codeTimer = setInterval(() => {
            this.time--;
            if (this.time === 0) {
              this.isSendCode = false;
              this.time = 60;
            }
          }, 1000);
          this.$message.success(this.$lang("获取手机验证码成功"));
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * @description 修改时要点击修改，输入框才能编辑
     */
    openEdit() {
      this.editDisable = false;
    },
    /**
     * @description 修改时要点击返回，重新请求数据，按钮输入框不可编辑
     */
    backStep() {
      this.editDisable = true;
      // 恢复表单默认值， 再去请求
      this.$refs["controlForm"].resetFields();
      this.isAuth("dev");
    },
    /**
     * @description 下一步
     */
    nextStep() {
      this.$refs.controlForm.validate((valid) => {
        if (valid) {
          // 21812 手机号前拼接区号
          let newParams = {
            userPhone: this.controlForm.countryCode + this.controlForm.userPhone,
            userName: this.controlForm.userName,
            userEmail: this.controlForm.userEmail,
            enterpriseName: this.controlForm.enterpriseName,
            enterpriseType: this.controlForm.enterpriseType,
            // userProvinceId: this.controlForm.userProvinceId,
            // userProvinceName: this.controlForm.userProvinceName,
            // userCityId: this.controlForm.userCityId,
            // userCityName: this.controlForm.userCityName,
            userProvinceId: this.controlForm.receiveAddress.userProvinceId,
            userProvinceName: this.controlForm.receiveAddress.userProvinceName,
            userCityId: this.controlForm.receiveAddress.userCityId,
            userCityName: this.controlForm.receiveAddress.userCityName,
            userAreaId: this.controlForm.receiveAddress.userAreaId,
            userAreaName: this.controlForm.receiveAddress.userAreaName,
            userDetailedAddress: this.controlForm.userDetailedAddress,
            captcha: this.controlForm.captcha,
            userId: this.user.id,
          };
          if (this.auditStatus !== 2) {
            this.$API.devCerCommit(newParams).then((res) => {
              if (res.code === RESPONSE_SUCCESS) {
                this.tabActive = 1;
                this.authLevel = 1;
                this.$message.success(this.$lang("开发者认证成功"));
                clearInterval(this.codeTimer);
                this.isSendCode = false;
                this.time = 60;
                // 恢复表单默认值， 再去请求
                this.$refs["controlForm"].resetFields();
                this.isAuth();
              } else {
                // this.isAuth() 如果失败了，这里停留在原页面，不应该再去请求认证信息
                this.$message.error(res.msg);
              }
            });
          } else {
            let params = {
              userName: this.controlForm.userName,
              userPhone: this.controlForm.countryCode + this.controlForm.userPhone,
              userEmail: this.controlForm.userEmail,
              phoneCode: this.controlForm.captcha,
              userId: this.user.id,
            };
            this.$API.updateCerCommit(params).then((res) => {
              if (res.code === RESPONSE_SUCCESS && res.data) {
                this.tabActive = 1;
                this.authLevel = 1;
                this.$message.success(this.$lang("开发者信息修改成功"));
                clearInterval(this.codeTimer);
                this.isSendCode = false;
                this.time = 60;
                // 恢复表单默认值， 再去请求
                this.$refs["controlForm"].resetFields();
                this.isAuth();
              } else {
                // this.isAuth() 如果失败了，这里停留在原页面，不应该再去请求认证信息
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * @description 获取省市区
     */
    getAreaList() {
      this.getFirsting = true;
      let params = {
        parentId: "1",
        type: "2",
      };
      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });
      this.$API.areaList(formData).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          // 酋长国获取列表
          this.provinceArray = [...res.data]
          this.addressOptions = res.data;
          this.getFirsting = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * @description 酋长国变化
     */
    dataProvinceChange(value) {
      this.getCityList(value)
    },
    /**
     * @description 区域变化
     */
    dataCityChange(value) {
      this.controlForm.userCityId = value
      const obj = this.cityList.find((item) => {
        return item.id === value
      })
      this.controlForm.userCityName = obj.nativeName
    },
    // 获取数据
    async getCityList(parentId) {
      let params = {
        parentId: parentId,
        type: "3",
      };
      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });
      this.$API.areaList(formData).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          // 区域获取列表
          this.cityList = [...res.data]
          this.controlForm.userProvinceId = parentId
          if(res.data && res.data.length > 0) {
            this.controlForm.userCityId = res.data[0].id
            this.controlForm.userCityName = res.data[0].nativeName
          } else {
            this.controlForm.userCityId = ''
            this.controlForm.userCityName = ''
          }
          
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.controlForm.userProvinceName = obj.nativeName
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /**
     * @description 企业认证提交信息，还是停留原页面
     */
    companyAuthSuccess() {
      this.isAuth();
    },
    /**
     * @description 企业认证被激活，就要实时去拿
     */
    pageActive() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          if (res.data.userCompany) {
            //已进行企业认证，这里要把获取的信息传给子组件，这里我们只关心企业信息有没有更新
            // 数据回显
            this.dataEcho(2, res.data.userCompany);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * @description 判断是否认证
     */
    isAuth(val) {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          // 这里需要判断是否认证通过，认证通过，并且uuid为空，即需要保存
          if (res.data.auditStatus == 2 && this.uuid.length == 0) {
            this.SET_UUID(res.data.uuid);
          }
          if (val === "edit") {
            this.auditStatus = "";
            this.auditStatus =
              !res.data.auditStatus && res.data.auditStatus !== 0
                ? ""
                : res.data.auditStatus;
            if (res.data.userCompany) {
              //已进行企业认证，这里要把获取的信息传给子组件
              this.authLevel = null;
              this.authLevel = res.data.auditStatus === 2 ? 2 : 1;
              // 数据回显
            }
          } else {
            this.authLevel = 0;
            if (res.data.userDev) {
              //已进行开发者认证
              this.authLevel = 1;
              // 数据回显
              this.dataEcho(1, res.data.userDev);
            }
            if (res.data.userCompany) {
              //已进行企业认证，这里要把获取的信息传给子组件，认证通过才能到达企业认证页面
              this.authLevel = res.data.auditStatus === 2 ? 2 : 1;
              // 数据回显
              this.dataEcho(2, res.data.userCompany);
            }
            //  allowApply:false,//是否允许开发者申请api  ： auditStatus 状态值为 (0,"已提交"),(1,"未认证"),(2,"已认证"),(3,"禁用");
            if (res.data.auditStatus && res.data.auditStatus == 2) {
              //已认证   允许申请api接口
              this.allowApply = true;
            }
            this.auditStatus = "";
            this.auditStatus =
              !res.data.auditStatus && res.data.auditStatus !== 0
                ? ""
                : res.data.auditStatus;
            // 210303 多了沙箱环境这个侧边栏选项，接口管理tabActive的值实际上是3
            this.tabActive = this.authLevel === 2 ? 3 : this.authLevel;
            if (this.$route.params.updateDevCer) {
              this.tabActive = 0;
              // 提交成功后都会调用isAuth这个方法，因为路由里updateDevCer这个参数一直存在，可能会有修改完企业信息跳到开发者信息的情况，因此，这个参数用一次就要删掉
              delete this.$route.params.updateDevCer;
            }
            if (val === "dev") {
              this.tabActive = 0;
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * @description 数据回显的方法
     */
    dataEcho(type, val) {
      if (type === 1) {
        // 数据回显-已进行开发者认证
        const {
          enterpriseName,
          userProvinceId,
          userProvinceName,
          userCityId,
          userCityName,
          userAreaId,
          userAreaName,
          enterpriseType,
          userDetailedAddress,
          userName,
          userPhone,
          userEmail,
        } = val;
        this.controlForm.enterpriseName = enterpriseName; // 公司名字
        this.controlForm.userProvinceId = userProvinceId; // 省份
        this.controlForm.userProvinceName = userProvinceName; // 省份
        this.controlForm.userCityId = userCityId;
        this.controlForm.userCityName = userCityName; // 城市
        this.controlForm.userAreaId = userAreaId;
        this.controlForm.userAreaName = userAreaName;
        this.controlForm.enterpriseType = String(enterpriseType); // 公司类型
        this.controlForm.userDetailedAddress = userDetailedAddress; // 公司详细地址
        this.controlForm.userName = userName; // 用户名
        this.controlForm.userEmail = userEmail; // 用户邮箱
        // 21812 手机号前拼接区号
        console.log(userPhone.substring(0,1), 'a')
        if(userPhone.substring(0,1) === '8') {
          this.controlForm.countryCode = 86
          this.controlForm.userPhone = userPhone.substring(2)
        } else if(userPhone.substring(0,1) === '9') {
          this.controlForm.countryCode = 55
          this.controlForm.userPhone = userPhone.substring(3)
        } else {
          console.log('进入这里了')
          this.controlForm.userPhone = userPhone; // 用户手机号
        }
        
        // 请求区域的列表
        let params = {
          parentId: userProvinceId,
          type: "3",
        };
        const formData = new FormData();
        Object.keys(params).forEach((key) => {
          formData.append(key, params[key]);
        });
        this.$API.areaList(formData).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          // 区域获取列表
          this.cityList = [...res.data]
        } else {
          this.$message.error(res.msg);
        }
      })
      }
      if (type === 2) {
        // 数据回显-已进行企业认证
        const {
          socialCreditCode,
          businessLicensePath,
          corporationName,
          corporationCardId,
          corporationProvinceId,
          corporationProvinceName,
          corporationCityId,
          corporationCityName,
          corporationAreaId,
          corporationAreaName,
          corporationDetailedAddress,
          corporationPhotoPath,
          remark,
        } = val;
        this.failReason = remark || ""; // 失败的原因，放在返回的企业信息对象里
        this.companyAuthFormSend.socialCreditCode = socialCreditCode;
        this.companyAuthFormSend.businessLicensePath = businessLicensePath;
        this.companyAuthFormSend.corporationName = corporationName;
        this.companyAuthFormSend.corporationCardId = corporationCardId;
        this.companyAuthFormSend.corporationProvinceId = corporationProvinceId;
        this.companyAuthFormSend.corporationProvinceName = corporationProvinceName;
        this.companyAuthFormSend.corporationCityId = corporationCityId;
        this.companyAuthFormSend.corporationCityName = corporationCityName;
        this.companyAuthFormSend.corporationAreaId = corporationAreaId;
        this.companyAuthFormSend.corporationAreaName = corporationAreaName;
        this.companyAuthFormSend.corporationDetailedAddress = corporationDetailedAddress;
        this.companyAuthFormSend.corporationPhotoPath = corporationPhotoPath;
      }
    },
    receiveAddress(rule, value, callback) {
      //验证地址
      if (this.controlForm.receiveAddress === "") {
        callback(new Error(this.$lang("请选择输入地址")));
        return;
      }
      const { userProvinceName, userCityName } =
        this.controlForm.receiveAddress;

      if (userProvinceName == "" || userCityName == "") {
        callback(new Error(this.$lang("请选择输入地址")));
      } else {
        callback();
      }
    },
    // receiveAddress(rule, value, callback) {
    //   //验证地址
    //   const { userProvinceName, userCityName } =
    //     this.controlForm;

    //   if (userProvinceName == "" || userCityName == "") {
    //     callback(new Error(this.$lang("请选择输入地址")));
    //   } else {
    //     callback();
    //   }
    // },
  },
  destroyed() {
    clearInterval(this.codeTimer);
  },
};
</script>

<style lang="scss" scoped>
.control {
  background: #f4f5f7;
  .control-wrap {
    padding: 20px 0;
    height: 100%;
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    .main-left {
      width: 240px;
      box-sizing: border-box;
      margin-right: 20px;
      background: #fff;
      border-radius: 10px;
      .main-left-header {
        position: relative;
        height: 71px;
        width: 100%;
        border-bottom: 1px solid $table-border-color;
        color: #2b2d42;
        font-size: 26px;
        font-weight: 900;
        line-height: 26px;
        padding: 22px 0 22px 20px;
        box-sizing: border-box;
        .line {
          width: 4px;
          height: 28px;
          background: $theme-color;
          border-radius: 2px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 22px;
        }
      }
      .main-left-aside {
        box-sizing: border-box;
        padding-left: 32px;
        .main-left-aside-item {
          font-size: 14px;
          font-weight: 400;
          color: #61666d;
          line-height: 16px;
          margin-top: 34px;
          cursor: pointer;
          &.first {
            margin-top: 47px;
          }
          &.active {
            color: $theme-color;
            font-weight: 600;
          }
        }
      }
    }
    .main-right {
      flex: 1;
      background: #fff;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      .main-right-header {
        box-sizing: border-box;
        padding: 30px 0 30px 30px;
        display: flex;
        border-bottom: 1px solid $table-border-color;
        .right-header-item {
          flex: 1;
          position: relative;
          display: flex;
          align-items: center;
          .iconfont.iconkongzhitai_wanchengbuzhou {
            // position: absolute;
            // top: 5px;
            // left: 0;
            font-size: 24px;
            color: $theme-color;
            transform: translateX(-10px);
          }
          .circle {
            // position: absolute;
            // top: 5px;
            // left: 0;
            width: 24px;
            height: 24px;
            background: $theme-color;
            font-size: 14px;
            text-align: center;
            color: #ffffff;
            border-radius: 50%;
            line-height: 24px;
            transform: translateX(-10px);
            &.grayClass {
              background: #dadee3;
            }
          }
          .right-header-flex{
            flex: 1;
          }
          .title {
            // position: absolute;
            // top: 0px;
            // left: 30px;
            display: block;
            font-size: 16px;
            font-weight: 600;
            color: #2b2d42;
            line-height: 16px;
          }
          .subTitle {
            display: block;
            font-size: 12px;
            font-weight: 400;
            color: #a1a3a6;
            line-height: 16px;
            margin-top: 5px;
          }
          .iconbuzhouhongsejiantou {
            font-size: 14px;
            margin-right: 26px;
            color: $theme-color;
            &.grayColor {
              color: #d2d8e0;
            }
          }
        }
        &.zh-cn{
          .right-header-item .subTitle{
              width: 72px;
          }
        }
       &.en {
          .right-header-item .subTitle{
            // text-align: justify;
            // -webkit-hyphens: auto;
            // -moz-hyphens: auto;
            // -ms-hyphens: auto;
            // hyphens: auto;
            padding-right: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 90px;
          }
        }
      }
      .main-right-content {
        box-sizing: border-box;
        padding: 30px 30px 15px;
        flex: 1;
        overflow-y: auto;
        .content-item {
          position: relative;
          h3 {
            font-size: 22px;
            color: #2b2d42;
            line-height: 22px;
            margin-bottom: 20px;
            .iconfont {
              color: $theme-color;
              font-size: 24px;
              margin-right: 16px;
              font-weight: normal;
            }
          }
          .audit-status {
            position: absolute;
            right: 0;
            top: -15px;
            font-size: 14px;
            text-align: right;
            .iconfont {
              margin-right: 6px;
              font-size: 14px;
            }
            .iconshenhezhuangtai_weishenqingshibai {
              color: #e60012;
            }
            .iconshenhezhuangtai_shenhezhong {
              color: rgb(45, 124, 255);
            }
            .iconshenhezhuangtai_tongguo {
              color: rgb(34, 206, 136);
            }
            span {
              color: #e60012;
            }
          }
          &.second {
            margin-top: 50px;
          }
          .sandbox-title {
            color: #2b2d42;
          }
        }
        &.en::v-deep{
          .el-form-item__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .nextStep {
      width: 450px;
      height: 40px;
      background-color: $theme-color;
      color: #fff;
      font-size: 14px;
      margin-left: 180px;
      margin-top: 8px;
    }
    .back {
      width: 215px;
      height: 40px;
      border: 1px solid #b0b3b6;
      border-radius: 4px;
      color: #61666d;
      font-weight: 400;
      margin-left: 180px;
    }
    .save {
      width: 215px;
      height: 40px;
      background-color: $theme-color;
      border-radius: 4px;
      color: #ffffff;
      margin-left: 20px;
    }
    .captchaItem {
      .sendCode {
        width: 88px;
        height: 40px;
        background-color: $theme-color;
        color: #fff;
        margin-left: 20px;
      }
    }
  }
}
.control::v-deep {
  .el-form-item {
    .el-form-item {
      margin-bottom: 0 !important;
    }
    .el-form-item.nth-2 {
      margin-left: 20px;
    }
  }
  .el-form-item__label {
    color: #4c4d57;
  }
  .el-input {
    width: 450px;
  }
  .userPhone {
    .el-input {
      width: 100%;
    }
    .el-input-group__prepend {
      width: 20%;
    }
  }
  .captchaItem .el-input {
    width: 342px;
  }
  .el-cascader .el-input {
    width: 200px;
  }
  .address {
    .el-input {
      width: 220px;
    }
  }
}

[dir="rtl"] .control {
  ::v-deep .el-tabs--top .el-tabs__item.is-top:last-child,
  .el-tabs--top .el-tabs__item.is-bottom:last-child,
  .el-tabs--bottom .el-tabs__item.is-top:last-child,
  .el-tabs--bottom .el-tabs__item.is-bottom:last-child {
    padding-left: 0;
    padding-right: 20px;
  }

  .control-wrap {
    .main-left {
      margin-left: 20px;
      margin-right: 0px;
      .main-left-header {
        padding: 22px 20px 22px 5px;
        .line {
          left: inherit;
          right: 0;
        }
      }
      .main-left-aside {
        padding: 0 32px 0 0;
      }
    }
    .main-right {
      .main-right-item h3 .iconfont {
        margin-left: 16px;
        margin-right: 0px;
      }
      .nextStep {
        margin-right: 180px;
        margin-left: 0;
      }
      .main-right-content ::v-deep {
        [class*="el-col-"] {
          float: right;
        }
        .audit-status {
          right: inherit;
          left: 0;
        }
        .el-form-item__label {
          float: right !important;
        }
        .nth-2 {
          margin-right: 20px;
          margin-left: 0;
        }
        .el-form-item__content {
          margin-right: 180px;
          margin-left: 0 !important;
          .el-form-item__content {
            margin-right: 0px;
          }
        }
        .el-tabs__nav {
          float: right;
        }
      }
    }
  }
}
::v-deep .cp-input {
  width: 450px;
  .el-input {
    width: 100% !important;
  }
}
</style>
